import { createWebHistory, createRouter } from "vue-router";
import { useLoginAuth } from "@/stores/LoginAuthStore";
import Body from '../components/body';

/* BIS */
//order
import OrderList from '@/pages/order/OrderList.vue'
import OrderListForSeller from '@/pages/order/seller/OrderList.vue'
import OrderListForBranch from '@/pages/order/branch/OrderList.vue'

import OrderRejectedList from '@/pages/order/OrderRejectedList.vue'

import OrderHappyCallList from '@/pages/order/OrderHappyCallList.vue'
import OrderHappyCallListForSeller from '@/pages/order/seller/OrderHappyCallList.vue'

import OrderRegister from '@/pages/order/OrderRegister.vue'
import OrderRegisterForSeller from '@/pages/order/seller/OrderRegister.vue'

import OrderModify from '@/pages/order/OrderModify.vue'

import OrderExcelList from '@/pages/order/OrderExcelList.vue'
import OrderExcelListForSeller from '@/pages/order/seller/OrderExcelList.vue'

// list(card, tax)
import OrderCardList from '@/pages/order/list/OrderCardList.vue'
import OrderTaxList from '@/pages/order/list/OrderTaxList.vue'

//as
// import ASList from '@/pages/afterService/ASList.vue'
// import ASListForSeller from '@/pages/afterService/seller/ASList.vue'
// import ASListForBranch from '@/pages/afterService/branch/ASList.vue'

import ASRegister from '@/pages/afterService/ASRegister.vue'
import ASRegisterForSeller from '@/pages/afterService/seller/ASRegister.vue'

import ASModify from '@/pages/afterService/ASModify.vue'

import ASExcelList from '@/pages/afterService/ASExcelList.vue'
import ASExcelListForSeller from '@/pages/afterService/seller/ASExcelList.vue'

//claim
import ClaimList from '@/pages/claim/ClaimList.vue'
import ClaimRegister from '@/pages/claim/ClaimRegister.vue'
import ClaimModify from '@/pages/claim/ClaimModify.vue'

//product
import BISProductList from '@/pages/product/ProductList.vue'
import BISProductListForSeller from '@/pages/product/seller/ProductList.vue'

import BISProductRegister from '@/pages/product/ProductRegister.vue'
import BISProductRegisterForSeller from '@/pages/product/seller/ProductRegister.vue'

import BISProductModify from '@/pages/product/ProductModify.vue'

//company
import CompanyList from '@/pages/company/CompanyList.vue'
import CompanyRegister from '@/pages/company/CompanyRegister.vue'
import CompanyModify from '@/pages/company/CompanyModify.vue'

//branch
import BranchList from '@/pages/branch/BranchList.vue'
import BranchRegister from '@/pages/branch/BranchRegister.vue'
import BranchModify from '@/pages/branch/BranchModify.vue'

//engineer
import EngineerList from '@/pages/engineer/EngineerList.vue'
import EngineerRegister from '@/pages/engineer/EngineerRegister.vue'
import EngineerModify from '@/pages/engineer/EngineerModify.vue'

//admin
import AdminList from '@/pages/admin/AdminList.vue'
import AdminRegister from '@/pages/admin/AdminRegister.vue'
import AdminModify from '@/pages/admin/AdminModify.vue'

//calculate
import CalculateCompList from '@/pages/calculate/CalculateCompList.vue'
import CalculateBISList from '@/pages/calculate/CalculateBISList.vue'

//delete
import DeleteList from '@/pages/delete/DeleteList.vue'



// Widgets
import General from '../pages/widgets/general'
import Chart from '../pages/widgets/chart'

// pageLayout
import indexBoxed from '../pages/pageLayout/boxed/indexBoxed.vue'
import indexRTL from '../pages/pageLayout/RTL/indexRTL.vue'
import indexDarklayout from '../pages/pageLayout/darklayout/indexDarklayout.vue'
import indexFooterdark from '../pages/pageLayout/footerdark/indexFooterdark.vue'
import indexFooterfixed from '../pages/pageLayout/footerfixed/indexFooterfixed.vue'
import indexFooterlight from '../pages/pageLayout/footerlight/indexFooterlight.vue'
import indexHidenavscroll from '../pages/pageLayout/hidenavscroll/indexHidenavscroll.vue'

/* File Manager  */
import FileManager from '../pages/filemanager';

// kanban
import Kanban from '../pages/kanban/indexKanban.vue'

// user
import userProfile from '../pages/users/profile/userProfile.vue'
import userCards from '../pages/users/cards/userCards.vue'
import userEdit from '../pages/users/edit/userEdit.vue'

// forms
import formValidation from "../pages/forms/formValidetion/formValidation"
import base_Input from "../pages/forms/baseInput/base_Input"
import checkbox_radio from "../pages/forms/Checkbox&Radio/checkbox_radio"
import input_groups from "../pages/forms/InputGroup/input_groups"
import megaOptions from "../pages/forms/megaOptions/megaOptions"

// form widgets
import select2 from "../pages/formWidgets/select2/select2Page.vue"
import switch_From from "../pages/formWidgets/switch/switch_From"
import touchspin_Form from "../pages/formWidgets/touchspin/touchspin_Form"
import typeahead_Form from "../pages/formWidgets/typeahead/typeahead_Form"
import clipboard_Form from "../pages/formWidgets/clipboard/clipboard_Form"
import datepicker from "../pages/formWidgets/datepicker/datePicker.vue"

// form layput
import defaultforms from '../pages/formLayout/default/defaultFotrm.vue'
import form_wizard2 from "../pages/formLayout/formWizrd2/form_wizard.vue"
import form_wizard1 from '../pages/formLayout/formWizard1/form_wizard2.vue'
import form_wizard3 from "../pages/formLayout/formWizard3/form_wizard1.vue"

// uikits
import Scrollable from "../pages/advance/scollable/scrollable_advance.vue";
import Sweetalert from "../pages/advance/sweetalert/sweetAert.vue";
import Tree from "../pages/advance/tree/treeView.vue";
import Rating from "../pages/advance/rating/ratingView.vue";
import Pagination from "../pages/advance/pagination/pagination_advance.vue";
import Ribbons from "../pages/advance/ribbons/ribbons_advance.vue";
import Tour from "../pages/advance/tour/tourView.vue";

import Breadcrumb from "../pages/advance/breadcrumbs/breadCrumb.vue";

import Sticky from "../pages/advance/sticky/stickyView.vue";

import Notify from '../pages/advance/notify/toaster_advance.vue'
import dropzone from '../pages/advance/dropzone/dropzoneView.vue';
import animatedModal from '../pages/advance/animatedModal/animatedModal.vue'
import owlCarousel from '../pages/advance/owlCarousel/owlCarousel.vue' 
import Rangeslider from '../pages/advance/range/rangeView.vue'
import BasicCard from '../pages/advance/basicCard/basicCard.vue'
import CreativeCard from '../pages/advance/creativeCard/creative_card.vue'
import DraggableCard from '../pages/advance/draggableCard/draggableCard.vue'
import TabbedCard from '../pages/advance/tabbedCard/tabbed_card.vue'
import timeLine from '../pages/advance/timeLine/timeLine.vue'

/* FAQ */
import Faq from '../pages/faq/faqIndex.vue';

// uikits
import alert from '../pages/uikits/alert';
import Helperclasses from '../pages/uikits/helper_classes';
import Avatars from '../pages/uikits/avatars';
import Grid from '../pages/uikits/grid';
import Tagpills from '../pages/uikits/tag_pills';
import Typography from '../pages/uikits/typography';
import Progressbar from '../pages/uikits/progress_bar';
import Modal from '../pages/uikits/modal';
import Popover from '../pages/uikits/popover';
import Tooltip from '../pages/uikits/tooltip';
import Spinners from '../pages/uikits/loader';
import Dropdown from '../pages/uikits/dropdown';
import Accordion from '../pages/uikits/accordion';
import Boxshadow from '../pages/uikits/box_shadow';
import Lists from '../pages/uikits/lists';
import bootstraptabPage from "../pages/uikits/tabs/bootstraptab/bootstraptabPage.vue";
import linetabPage from "../pages/uikits/tabs/linetab/linetabPage.vue";

// animation
import animate from '../pages/animation/animate/animatePage.vue'
import aos from '../pages/animation/aos/aosPage.vue'
import scroll from '../pages/animation/scroll/scrollPage.vue'
import wow from '../pages/animation/wow/wowPage.vue'
import tilt from '../pages/animation/tilt.vue'

// builder
import form1 from '../pages/builder/formBuilder1.vue'
import form2 from '../pages/builder/formBuilder2.vue'

/* icons */
import Flag from '../pages/icons/flag';
import Ico from '../pages/icons/ico_icon';
import Themify from '../pages/icons/themify_icon';
import Fontawesome from '../pages/icons/font_awesome';
import FeatherIcon from '../pages/icons/feather_icon';
import WhetherIcon from '../pages/icons/weather';

/* Buttons */
import Default_buttons from '../pages/button/Default/default_button.vue';
import Flat_buttons from '../pages/button/Flat/flat_button.vue';
import Edge_buttons from '../pages/button/Edge/edge_button.vue';
import Raised_buttons from '../pages/button/Raised/raised_button.vue';
import Group_buttons from '../pages/button/ButtonGroup/button_group.vue'; 

/*charts*/ 
import google_chart from "../pages/charts/googleChart/google_chart"
import apex_chart from "../pages/charts/ApexChart/apex_chart"
import chartist_chart from "../pages/charts/chartist/chartist_chart.vue"

// error
import Error400 from '../pages/error/error400';
import Error401 from '../pages/error/error401';
import Error403 from '../pages/error/error403';
import Error404 from '../pages/error/error404';
import Error500 from '../pages/error/error500';
import Error503 from '../pages/error/error503';

/* Support Ticket */
import Support from '../pages/support/support.vue';

/* Editor */
import SimpleEditor from '../pages/editor/simple_editor';
import CkEditor from '../pages/editor/ckeditor.vue';

/* Maps */
import GoogleMaps from '../pages/maps/google_map.vue';
import VueLeaflet from '../pages/maps/vue_leaflet.vue';

// GALLERY
import grid_gallery from "../pages/gallery/grid_gallery"
import grid_desc from "../pages/gallery/grid_desc"
import hover_gallery from "../pages/gallery/hover-gallery/hover_gallery"
import masonry_gallery from "../pages/gallery/masonry-gallery/masonry_gallery"
import masonary_desc from "../pages/gallery/masonary_desc.vue"

/* Authentication */
import LoginOne from '../pages/authentication/login_one';
import LoginTwo from '../pages/authentication/login_two';
import LoginValidate from '../pages/authentication/login_validation.vue';
import LoginTooltip from '../pages/authentication/login_tooltip.vue'
import LoginSweetalert from '../pages/authentication/login_sweetalert.vue'

import RegisterImage from '../pages/authentication/register_image';
import RegisterImage2 from '../pages/authentication/register_image2';
import Unlock from '../pages/authentication/unlock';
import ForgetPassword from '../pages/authentication/forget_password';
import ResetPassword from '../pages/authentication/reset_password';
import Maintenance from '../pages/authentication/maintenance.vue'

/* Auth */
import LoginView from '@/pages/auth/LoginView'
import login from '../auth/login';
import Register from '../auth/register';

// comingsoon
import ComingsoonImage from '../pages/comingsoon/comingsoon_image';
import ComingsoonSimple from '../pages/comingsoon/comingsoon_simple';
import ComingsoonVideo from '../pages/comingsoon/comingsoon_video';

// SAMPLE PAGE
import sample_page from "../pages/sample_page"

/* bootstrap tables */
import BootstrapBasic from "../pages/tables/bootstrapTable/basicTables/basic_tables.vue";
import tableComponent from "../pages/tables/bootstrapTable/stylingtable/styling_table.vue"
import DatatableBasic from "../pages/tables/dataTable/BasicInit/basic_Init.vue"

// searchPage
import serchIndex from "../pages/search/serchIndex.vue"
// bookmark
import Bookmark from "../pages/bookmark/bookMark.vue"
// contact 
import contactView from "../pages/contact/contactView.vue"
// task
import Task from "../pages/task/indexPage.vue"
// calendar
import Calendar from "../pages/calenderView.vue"
// social app
import socialPage from "../pages/socialApp/socialApp.vue"
// todo
import Todo from "../pages/todo/index.vue"

const routes = [
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView,
    meta: {
      title: '로그인 | Web Admin - bis'
    }
  },
    {
      path: '/',
      component: Body,
  
      children: [
        {
          path: '',
          name: 'defaultRoot',
          component: OrderList,
          meta: {
            title: ' BIS - Back Office',
          }
        },
  
      ]
    },
    {
      path: '/order',
      component: Body,
  
      children: [
        {
          path: 'list',
          name: 'orderList',
          component: OrderList,
          meta: {
            title: ' 주문 목록 - Back Office',
          }
        },
        {
          path: 'list/seller',
          name: 'orderListForSeller',
          component: OrderListForSeller,
          meta: {
            title: ' 주문 목록 - Back Office',
          }
        },
        {
          path: 'list/branch',
          name: 'orderListForBranch',
          component: OrderListForBranch,
          meta: {
            title: ' 주문 목록 - Back Office',
          }
        },

        {
          path: 'happycall',
          name: 'orderHappyCallList',
          component: OrderHappyCallList,
          meta: {
            title: ' 해피콜 목록 - Back Office',
          }
        },
        {
          path: 'happycall/seller',
          name: 'orderHappyCallListForSeller',
          component: OrderHappyCallListForSeller,
          meta: {
            title: ' 해피콜 목록 - Back Office',
          }
        },

        {
          path: 'return',
          name: 'returnList',
          component: OrderRejectedList,
          meta: {
            title: ' 반려 목록 - Back Office',
          }
        },
        {
          path: 'register',
          name: 'orderRegister',
          component: OrderRegister,
          meta: {
            title: ' 주문 등록 - Back Office',
          }
        },
        {
          path: 'register/seller',
          name: 'orderRegisterForSeller',
          component: OrderRegisterForSeller,
          meta: {
            title: ' 주문 등록 - Back Office',
          }
        },
        {
          path: 'modify/:id',
          name: 'orderModify',
          component: OrderModify,
          meta: {
            title: ' 주문 수정 - Back Office',
          }
        },
        {
          path: 'excel',
          name: 'orderExcelList',
          component: OrderExcelList,
          meta: {
            title: ' 주문 엑셀 등록 - Back Office',
          }
        },
        {
          path: 'excel/seller',
          name: 'orderExcelListForSeller',
          component: OrderExcelListForSeller,
          meta: {
            title: ' 주문 엑셀 등록 - Back Office',
          }
        },
  
      ]
    },
    {
      path: '/afterservice',
      component: Body,
  
      children: [
        // {
        //   path: 'list',
        //   name: 'ASList',
        //   component: ASList,
        //   meta: {
        //     title: ' A/S 목록 - Back Office',
        //   }
        // },
        // {
        //   path: 'list/seller',
        //   name: 'ASListForSeller',
        //   component: ASListForSeller,
        //   meta: {
        //     title: ' A/S 목록 - Back Office',
        //   }
        // },
        // {
        //   path: 'list/branch',
        //   name: 'ASListForBranch',
        //   component: ASListForBranch,
        //   meta: {
        //     title: ' A/S 목록 - Back Office',
        //   }
        // },

        {
          path: 'register',
          name: 'ASRegister',
          component: ASRegister,
          meta: {
            title: ' A/S 등록 - Back Office',
          }
        },
        {
          path: 'register/seller',
          name: 'ASRegisterForSeller',
          component: ASRegisterForSeller,
          meta: {
            title: ' A/S 등록 - Back Office',
          }
        },

        {
          path: 'modify/:id',
          name: 'ASModify',
          component: ASModify,
          meta: {
            title: ' A/S 수정 - Back Office',
          }
        },
        
        {
          path: 'excel',
          name: 'ASExcelList',
          component: ASExcelList,
          meta: {
            title: ' A/S 엑셀 등록 - Back Office',
          }
        },

        {
          path: 'excel/seller',
          name: 'ASExcelListForSeller',
          component: ASExcelListForSeller,
          meta: {
            title: ' A/S 엑셀 등록 - Back Office',
          }
        },
  
      ]
    },
    {
      path: '/claim',
      component: Body,
  
      children: [
        {
          path: 'list',
          name: 'claimList',
          component: ClaimList,
          meta: {
            title: ' 클레임 목록 - Back Office',
          }
        },

        {
          path: 'register',
          name: 'claimRegister',
          component: ClaimRegister,
          meta: {
            title: ' 클레임 등록 - Back Office',
          }
        },
        {
          path: 'modify/:id',
          name: 'claimModify',
          component: ClaimModify,
          meta: {
            title: ' 클레임 수정 - Back Office',
          }
        },
      ]
    },
    {
      path: '/product',
      component: Body,
  
      children: [
        {
          path: 'list',
          name: 'BISProductList',
          component: BISProductList,
          meta: {
            title: ' 상품 목록 - Back Office',
          }
        },
        {
          path: 'list/seller',
          name: 'BISProductListForSeller',
          component: BISProductListForSeller,
          meta: {
            title: ' 상품 목록 - Back Office',
          }
        },

        {
          path: 'register',
          name: 'BISProductRegister',
          component: BISProductRegister,
          meta: {
            title: ' 상품 등록 - Back Office',
          }
        },
        {
          path: 'register/seller',
          name: 'BISProductRegisterForSeller',
          component: BISProductRegisterForSeller,
          meta: {
            title: ' 상품 등록 - Back Office',
          }
        },
        {
          path: 'modify/:id',
          name: 'BISProductModify',
          component: BISProductModify,
          meta: {
            title: ' 상품 수정 - Back Office',
          }
        },
      ]
    },
    {
      path: '/company',
      component: Body,
  
      children: [
        {
          path: 'list',
          name: 'companyList',
          component: CompanyList,
          meta: {
            title: ' 업체 목록 - Back Office',
          }
        },

        {
          path: 'register',
          name: 'companyRegister',
          component: CompanyRegister,
          meta: {
            title: ' 업체 등록 - Back Office',
          }
        },
        {
          path: 'modify/:id',
          name: 'companyModify',
          component: CompanyModify,
          meta: {
            title: ' 업체 수정 - Back Office',
          }
        },
      ]
    },
    {
      path: '/branch',
      component: Body,
  
      children: [
        {
          path: 'list',
          name: 'branchList',
          component: BranchList,
          meta: {
            title: ' 지사 목록 - Back Office',
          }
        },
        {
          path: 'register',
          name: 'branchRegister',
          component: BranchRegister,
          meta: {
            title: ' 지사 등록 - Back Office',
          }
        },
        {
          path: 'modify/:id',
          name: 'branchModify',
          component: BranchModify,
          meta: {
            title: ' 지사 수정 - Back Office',
          }
        },
        
      ]
    },
    {
      path: '/engineer',
      component: Body,
  
      children: [
        {
          path: 'list',
          name: 'engineerList',
          component: EngineerList,
          meta: {
            title: ' 기사 목록 - Back Office',
          }
        },

        {
          path: 'register',
          name: 'engineerRegister',
          component: EngineerRegister,
          meta: {
            title: ' 기사 등록 - Back Office',
          }
        },
        {
          path: 'modify/:id',
          name: 'engineerModify',
          component: EngineerModify,
          meta: {
            title: ' 기사 수정 - Back Office',
          }
        },
      ]
    },
    {
      path: '/admin',
      component: Body,
  
      children: [
        {
          path: 'list',
          name: 'adminList',
          component: AdminList,
          meta: {
            title: ' 관리자 목록 - Back Office',
          }
        },

        {
          path: 'register',
          name: 'adminRegister',
          component: AdminRegister,
          meta: {
            title: ' 관리자 등록 - Back Office',
          }
        },
        {
          path: 'modify/:id',
          name: 'adminModify',
          component: AdminModify,
          // props: true,
          meta: {
            title: ' 관리자 수정 - Back Office',
          }
        },
      ]
    },
    {
      path: '/calculate',
      component: Body,
  
      children: [
        {
          path: 'comp/list',
          name: 'calculateCompList',
          component: CalculateCompList,
          meta: {
            title: ' 업체정산 목록 - Back Office',
          }
        },

        {
          path: 'bis/list',
          name: 'calculateBISList',
          component: CalculateBISList,
          meta: {
            title: ' BIS 정산 목록 - Back Office',
          }
        },
      ]
    },
    {
      path: '/delete',
      component: Body,
      children: [
        {
          path: 'list',
          name: 'deleteList',
          component: DeleteList,
          meta: {
            title: ' 삭제 목록 - Back Office',
          }
        },
      ]
    },
    {
      path: '/list',
      component: Body,
      children: [
        {
          path: 'card',
          name: 'cardList',
          component: OrderCardList,
          meta: {
            title: ' 카드 목록 - Back Office',
          }
        },
        {
          path: 'tax',
          name: 'taxList',
          component: OrderTaxList,
          meta: {
            title: ' 세금계산서 목록 - Back Office',
          }
        },
      ]
    },
    
      {
        path: '/widgets',
        component: Body,
        meta: {
          requiresAuth: true
        },
        children: [
        {
          path: 'general',
          name: 'general',
          component: General,
          meta: {
            title: 'general Dashboard | Cuba - Premium Admin Template',
          }
        },
        {
          path: 'chart',
          name: 'chart',
          component: Chart,
          meta: {
            title: 'chart Dashboard | Cuba - Premium Admin Template',
          }
        },
        ]
      },
      {
        path: '/pageLayout',
        component: Body,
        children: [
          {
            path: 'boxed',
            name: 'boxed',
            component: indexBoxed,
            meta: {
              title: 'Boxed | Cuba - Premium Admin Template',
            }
          },
          {
            path: 'darklayout',
            name: 'darklayout',
            component: indexDarklayout,
            meta: {
              title: 'Dark Layout | Cuba - Premium Admin Template',
            }
          }
          ,
          {
            path: 'footerdark',
            name: 'footerdark',
            component: indexFooterdark,
            meta: {
              title: 'Footer Dark | Cuba - Premium Admin Template',
            }
          }
          ,
          {
            path: 'footerlight',
            name: 'footerlight',
            component: indexFooterlight,
            meta: {
              title: 'Footer Light | Cuba - Premium Admin Template',
            }
          }
          ,
          {
            path: 'footerfixed',
            name: 'footerfixed',
            component: indexFooterfixed,
            meta: {
              title: 'Footer Fixed | Cuba - Premium Admin Template',
            }
          }
          ,
          {
            path: 'hidenavscroll',
            name: 'hidenavscroll',
            component: indexHidenavscroll,
            meta: {
              title: 'Hide Nav Scroll | Cuba - Premium Admin Template',
            }
          }
          ,
          {
            path: 'RTL',
            name: 'RTL',
            component: indexRTL,
            meta: {
              title: 'RTL | Cuba - Premium Admin Template',
            }
          }
        ]
      },
      
      {
        path: '/app',
        component: Body,
        children: [
          {
            path: 'socialPage',
            name: 'socialPage',
            component: socialPage,
             meta: {
                title: 'Social App, | Cuba - Premium Admin Template',
              }
          },
        {
          path: 'todo',
          name: 'todo',
          component: Todo,
           meta: {
              title: 'Todo | Cuba - Premium Admin Template',
            }
        },

        {
          path: 'filemanager',
          name: 'File Manager',
          component: FileManager,
           meta: {
              title: 'File Manager, | Cuba - Premium Admin Template',
            }
        },
        {
          path: 'kanban',
          name: 'Kanban Board',
          component: Kanban,
           meta: {
              title: 'Kanban Board, | Cuba - Premium Admin Template',
            }
        },
        {
          path: 'contact',
          component: contactView,
          name: 'contactView',
          meta: {
            title: 'Contacts | Cuba - Premium Admin Template',
          }
        },
        {
          path:'bookmark',
          name:'Bookmark',
          component:Bookmark,
          meta: {
            title: 'Bookmark | Cuba - Premium Admin Template',
          }
        },
        {
          path:'task',
          name:'Task',
          component:Task,
          meta: {
            title: 'Task | Cuba - Premium Admin Template',
          }
        },
        {
          path:'calendar',
          name:'Calendar',
          component:Calendar,
          meta: {
            title: 'Calendar | Cuba - Premium Admin Template',
          }
        }
        ]
      },
      
      {
        path: '/users',
        component: Body,
        children: [
          {
            path: "profile",
            name: "profile",
            component: userProfile,
            meta: {
              title: "Users Profile | Cuba - Premium Admin Template",
            },
          },
          {
            path: "edit",
            name: "edit",
            component: userEdit,
            meta: {
              title: "Users Edit | Cuba - Premium Admin Template",
            },
          },
          {
            path: "cards",
            name: "cards",
            component: userCards,
            meta: {
              title: "Users Cards | Cuba - Premium Admin Template",
            },
          }
        ]
      },
      {
        path:"/form",
        component:Body,
        children:[
          {
            path:"validation",
            name:"formValidation",
            component:formValidation,
            meta: {
              title: "Form Validation | Cuba - Premium Admin Template",
            },
          },
          {
            path:"inputs",
            name:"basicInput",
            component:base_Input,
            meta: {
              title: "Base Inputs | Cuba - Premium Admin Template",
            },
          },
          {
            path:"checkbox-radio",
            name:"checkbox & radio",
            component:checkbox_radio,
            meta: {
              title: "Checkbox & Radio | Cuba - Premium Admin Template",
            },
          },
          {
            path:"input-groups",
            name:"input Groups",
            component:input_groups,
            meta: {
              title: "Input Groups | Cuba - Premium Admin Template",
            },
          },
          {
            path:"mega-options",
            name:"megaOptions",
            component:megaOptions,
            meta: {
              title: "Mega Options | Cuba - Premium Admin Template",
            },
          },
          {
            path:"select2",
            name:"select2",
            component:select2,
            meta: {
              title: "Select2 | Cuba - Premium Admin Template",
            },
          },
          {
            path:"switch",
            name:"switch",
            component:switch_From,
            meta: {
              title: "Switch | Cuba - Premium Admin Template",
            },
          },
          {
            path:"touchspin",
            name:"touchspin",
            component:touchspin_Form,
            meta: {
              title: "Touchspin | Cuba - Premium Admin Template",
            },
          },
          {
            path:"typeahead",
            name:"typeahead",
            component:typeahead_Form,
            meta: {
              title: "Typeahead | Cuba - Premium Admin Template",
            },
          },
          {
            path:"clipboard",
            name:"clipboard",
            component:clipboard_Form,
            meta: {
              title: "Clipboard | Cuba - Premium Admin Template",
            },
          },
          {
            path:"wizard2",
            name:"form_wizard2",
            component:form_wizard2,
            meta: {
              title: "Form Wizard2 | Cuba - Premium Admin Template",
            },
          },
          {
            path:"wizard1",
            name:"formwizard",
            component:form_wizard1,
            meta: {
              title: "Form Wizard1 | Cuba - Premium Admin Template",
            },
          },
          {
            path:"wizard3",
            name:"formwizard3",
            component:form_wizard3,
            meta: {
              title: "Form Wizard3 | Cuba - Premium Admin Template",
            },
          },
          {
            path:"defaultforms",
            name:"defaultforms",
            component:defaultforms,
            meta: {
              title: "Default Forms | Cuba - Premium Admin Template",
            },
          },
          {
            path:"datepicker",
            name:"datepicker",
            component:datepicker,
            meta: {
              title: "Datepicker | Cuba - Premium Admin Template",
            },
          },
          
        ]
      },
      {
        path: "/advance",
        component: Body,
        children: [
            {
                path: "scrollable",
                name: "Scrollable",
                component: Scrollable,
                meta: {
                    title: "Scrollable | Cuba - Premium Admin Template",
                },
            },
            {
              path: "treeView",
              name: "Tree",
              component: Tree,
              meta: {
                  title: "Tree | Cuba - Premium Admin Template",
              },
          },
            {
              path: "notify",
              name: "notify",
              component: Notify,
              meta: {
                  title: "Scrollable | Cuba - Premium Admin Template",
              },
            },
            {
              path: "rating",
              name: "Rating",
              component: Rating,
              meta: {
                  title: "Rating | Cuba - Premium Admin Template",
              },
          },
          {
            path: "dropzone",
            name: "dropzone",
            component: dropzone,
            meta: {
                title: "dropzone | Cuba - Premium Admin Template",
            },
        },
        {
          path: "tour",
          name: "Tour",
          component: Tour,
          meta: {
              title: "Tour | Cuba - Premium Admin Template",
          },
      },
            {
                path: "sweetalert",
                name: "Sweetalert",
                component: Sweetalert,
                meta: {
                    title: "Sweetalert | Cuba - Premium Admin Template",
                },
            },
            {
              path: "animatedModal",
              name: "animatedModal",
              component: animatedModal,
              meta: {
                  title: "Sweetalert | Cuba - Premium Admin Template",
              },
          },
          {
            path: "owlCarousel",
            name: "owlCarousel",
            component: owlCarousel,
            meta: {
                title: "Sweetalert | Cuba - Premium Admin Template",
            },
        },
           
            {
                path: "ribbons",
                name: "Ribbons",
                component: Ribbons,
                meta: {
                    title: "Ribbons | Cuba - Premium Admin Template",
                },
            },
            {
              path: "pagination",
              name: "Pagination",
              component: Pagination,
              meta: {
                  title: "Pagination | Cuba - Premium Admin Template",
              },
          },
          {
            path: "breadcrumb",
            name: "Breadcrumb",
            component: Breadcrumb,
            meta: {
                title: "Breadcrumb | Cuba - Premium Admin Template",
            },
        },
            {
                path: "range-slider",
                name: "Rangeslider",
                component: Rangeslider,
                meta: {
                    title: "Rangeslider | Cuba - Premium Admin Template",
                },
            },
                        
            {
                path: "sticky",
                name: "Sticky",
                component: Sticky,
                meta: {
                    title: "Sticky | Cuba - Premium Admin Template",
                },
            },
            {
              path: "basicCard",
              name: "basicCard",
              component: BasicCard,
              meta: {
                  title: "Sticky | Cuba - Premium Admin Template",
              },
          },
          {
            path: "creativeCard",
            name: "creativeCard",
            component: CreativeCard,
            meta: {
                title: "Sticky | Cuba - Premium Admin Template",
            },
        },
        {
          path: "TabbedCard",
          name: "TabbedCard",
          component: TabbedCard,
          meta: {
              title: "Sticky | Cuba - Premium Admin Template",
          },
      },
      {
        path: "DraggableCard",
        name: "DraggableCard",
        component: DraggableCard,
        meta: {
            title: "Sticky | Cuba - Premium Admin Template",
        },
    },
            {
                path: "timeline1",
                name: "timeline",
                component: timeLine,
                meta: {
                    title: "Toastr | Cuba - Premium Admin Template",
                },
            },
        ],
    },
    {
      path:"/chart",
      component:Body,
      children:[
        {
          path:"google",
          name:"googlechart",
          component:google_chart,
          meta: {
            title: "Google Chart | Cuba - Premium Admin Template",
        },
        },
        {
          path:"apexChart",
          name:"apexchart",
          component:apex_chart,
          meta: {
            title: "ApexChart | Cuba - Premium Admin Template",
        },
        },
        {
          path:"chartist",
          name:"chartist",
          component:chartist_chart,
          meta: {
            title: "Chartist | Cuba - Premium Admin Template",
        },
        },
  
      ]
    },
    {
      path: '/pages',
      component: Body,
      children:[
        {
          path:'/pages/faq',
          name:'Faq',
          component:Faq,
          meta: {
          title: 'Faq | Cuba - Premium Admin Template',
        }
        },
          {
            path:'/pages/support',
            name:'Support',
            component:Support,
            meta: {
            title: 'Support | Cuba - Premium Admin Template',
          }
          },
          {
            path:'sample-page',
            name:'sample-page',
            component:sample_page,
            meta: {
                title: 'sample-page | Cuba - Premium Admin Template',
              }
          },
          {
      path:"search",
      name:"search",
      component:serchIndex
    },
        
      ]
    },
    {
      path: '/uikits',
      component: Body,
      children: [
      {
        path: 'alert',
        name: 'alert',
        component: alert,
        meta: {
          title: 'Alert | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'helper-classes',
        name: 'Helperclasses',
        component: Helperclasses,
        meta: {
          title: 'Helperclasses | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'avatars',
        name: 'Avatars',
        component: Avatars,
        meta: {
          title: 'Avatars | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'grid',
        name: 'Grid',
        component: Grid,
        meta: {
          title: 'Grid | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'tag-pills',
        name: 'Tagpills',
        component: Tagpills,
        meta: {
          title: 'Tagpills | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography,
        meta: {
          title: 'Typography | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'progress-bar',
        name: 'Progressbar',
        component: Progressbar,
        meta: {
          title: 'Progressbar | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'modal',
        name: 'Modal',
        component: Modal,
        meta: {
          title: 'Modal | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'popover',
        name: 'Popover',
        component: Popover,
        meta: {
          title: 'Popover | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'tooltip',
        name: 'Tooltip',
        component: Tooltip,
        meta: {
          title: 'Tooltip | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'loader',
        name: 'Spinners',
        component: Spinners,
        meta: {
          title: 'Spinners | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'dropdown',
        name: 'Dropdown',
        component: Dropdown,
        meta: {
          title: 'Dropdown | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'accordion',
        name: 'Accordion',
        component: Accordion,
        meta: {
          title: 'Accordion | Cuba - Premium Admin Template',
        }
      },
      {
        path: "bootstraptab",
        name: "bootstraptabPage",
        component: bootstraptabPage,
        meta: {
          title: "tab | Cuba - Premium Admin Template",
        },
      },
      {
        path: "linetab",
        name: "linetabPage",
        component: linetabPage,
        meta: {
          title: "Accordion | Cuba - Premium Admin Template",
        },
      },
      {
        path: 'box-shadow',
        name: 'Boxshadow',
        component: Boxshadow,
        meta: {
          title: 'Boxshadow | Cuba - Premium Admin Template',
        }
      },
      {
        path: 'lists',
        name: 'Lists',
        component: Lists,
        meta: {
          title: 'Lists | Cuba - Premium Admin Template',
        }
      }
      ]
    },
    {
      path: "/animation",
      component: Body,
      children: [
          {
              path: "animate",
              name: "animate",
              component: animate,
              meta: {
                  title: "animate | Cuba - Premium Admin Template",
              },
          },
          {
            path: "scroll",
            name: "scroll",
            component: scroll,
            meta: {
                title: "scroll | Cuba - Premium Admin Template",
            },
        },
          {
            path: "AOS",
            name: "aos",
            component: aos,
            meta: {
                title: "aos | Cuba - Premium Admin Template",
            },
          },
     
        {
          path: "wow",
          name: "wow",
          component: wow,
          meta: {
              title: "wow | Cuba - Premium Admin Template",
          },
      },
      {
        path: "tilt",
        name: "tilt",
        component: tilt,
        meta: {
            title: "tilt | Cuba - Premium Admin Template",
        },
    },
        ],
    },
    {
      path:"/builder",
      component: Body,
      children:[
        {
          path: "form1",
          name: "Form Builder1",
          component: form1,
          meta: {
            title: "from1 | Cuba - Premium Admin Template",
          },
        },
        {
          path: "form2",
          name: "Form Builder2",
          component: form2,
          meta: {
            title: "from2 | Cuba - Premium Admin Template",
          },
        }
      ]
    },
    {
      path: '/icons',
      component: Body,
      children:[
      {
        path: 'flag',
        name: 'Flag',
        component: Flag,
         meta: {
            title: 'Flag | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'ico',
        name: 'Ico',
        component: Ico,
         meta: {
            title: 'Ico | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'themify',
        name: 'Themify',
        component: Themify,
         meta: {
            title: 'Themify | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'fontawesome',
        name: 'Fontawesome',
        component: Fontawesome,
         meta: {
            title: 'Fontawesome | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'feather_icon',
        name: 'FeatherIcon',
        component: FeatherIcon,
         meta: {
            title: 'FeatherIcon | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'whether',
        name: 'WhetherIcon',
        component: WhetherIcon,
         meta: {
            title: 'WhetherIcon | Cuba - Premium Admin Template',
          }
      }
      ]
    },
    {
      path: '/buttons',
      component: Body,
      children:[
      {
        path: 'default',
        name: 'default_buttons',
        component: Default_buttons,
         meta: {
            title: 'Default_buttons | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'flat',
        name: 'flat_buttons',
        component: Flat_buttons,
         meta: {
            title: 'Flat_buttons | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'edge',
        name: 'edge_buttons',
        component: Edge_buttons,
         meta: {
            title: 'Edge_buttons | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'raised',
        name: 'raised_buttons',
        component: Raised_buttons,
         meta: {
            title: 'Raised_buttons | Cuba - Premium Admin Template',
          }
      },
      {
        path: 'group',
        name: 'group_buttons',
        component: Group_buttons,
         meta: {
            title: 'Group_buttons | Cuba - Premium Admin Template',
          }
      }
      ]
    },
    
    {
      path:'/error-400',
      name:'Error400',
      component:Error400,
      meta: {
          title: 'Error400 | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/error-401',
      name:'Error401',
      component:Error401,
      meta: {
          title: 'Error401 | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/error-403',
      name:'Error403',
      component:Error403,
      meta: {
          title: 'Error403 | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/error-404',
      name:'Error404',
      component:Error404,
      meta: {
          title: 'Error404 | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/error-500',
      name:'Error500',
      component:Error500,
      meta: {
          title: 'Error500 | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/error-503',
      name:'Error503',
      component:Error503,
      meta: {
          title: 'Error503 | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/login/one',
      name:'LoginOne',
      component:LoginOne,
      meta: {
          title: 'LoginOne | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/login/two',
      name:'LoginTwo',
      component:LoginTwo,
      meta: {
          title: 'LoginTwo | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/login/validate',
      name:'LoginValidate',
      component:LoginValidate,
      meta: {
          title: 'LoginValidate | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/login/tooltip',
      name:'LoginTooltip',
      component:LoginTooltip,
      meta: {
          title: 'LoginTooltip | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/login/sweetalert',
      name:'LoginSweetalert',
      component:LoginSweetalert,
      meta: {
          title: 'LoginTooltip | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/register/image',
      name:'RegisterImage',
      component:RegisterImage,
      meta: {
          title: 'RegisterImage | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/register/image2',
      name:'RegisterImage2',
      component:RegisterImage2,
      meta: {
          title: 'RegisterImage2 | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/unlockuser',
      name:'Unlock',
      component:Unlock,
      meta: {
          title: 'Unlock | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/forgetpassword',
      name:'ForgetPassword',
      component:ForgetPassword,
      meta: {
          title: 'ForgetPassword | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/resetpassword',
      name:'ResetPassword',
      component:ResetPassword,
      meta: {
          title: 'ResetPassword | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/authentication/maintenance',
      name:'Maintenance',
      component:Maintenance,
      meta: {
          title: 'ResetPassword | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/comingsoon/comingsoon-image',
      name:'ComingsoonImage',
      component:ComingsoonImage,
      meta: {
          title: 'ComingsoonImage | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/comingsoon/comingsoon-simple',
      name:'ComingsoonSimple',
      component:ComingsoonSimple,
      meta: {
          title: 'ComingsoonSimple | Cuba - Premium Admin Template',
        }
    },
    {
      path:'/comingsoon/comingsoon-video',
      name:'ComingsoonVideo',
      component:ComingsoonVideo,
      meta: {
          title: 'ComingsoonVideo | Cuba - Premium Admin Template',
        }
    },
 
    {
      path: '/editor',
      component: Body,
      children:[
        {
          path: 'simple-editor',
          name: 'SimpleEditor',
          component:SimpleEditor,
          meta: {
            title: 'SimpleEditor | Cuba - Premium Admin Template',
          }
        },
        {
          path: 'ck-editor',
          name: 'CkEditor',
          component:CkEditor,
           meta: {
            title: 'CkEditor | Cuba - Premium Admin Template',
          }
          
        }
      ]
    },
    {
      path:'/maps',
      component: Body,
      children:[
        {
          path: 'vue-google-maps',
          name: 'GoogleMaps',
          component:GoogleMaps,
           meta: {
            title: 'oogleMaps | Cuba - Premium Admin Template',
          }
        },
        {
          path: 'vue-leaflet-maps',
          name: 'VueLeaflet',
          component:VueLeaflet,
           meta: {
            title: 'ueLeaflet | Cuba - Premium Admin Template',
          }
        }
      ]
    },
    
      {
        path:"/gallery",
        component:Body,
        children:[
          {
            path:"grid-gallery",
            name:"gridgallery",
            component:grid_gallery,
            meta: {
              title: 'Grid Gallery | Cuba - Premium Admin Template',
            }
          },
          {
            path:"gallery-desc",
            name:"griddesc",
            component:grid_desc,
            meta: {
              title: 'Grid Gallery With Desc | Cuba - Premium Admin Template',
            }
          },
          {
            path:"hover-effect",
            name:"hovergallery",
            component:hover_gallery,
            meta: {
              title: 'Hover Effect | Cuba - Premium Admin Template',
            }
          },
          {
            path:"gallery-masonary",
            name:"masonry-gallery",
            component:masonry_gallery,
            meta: {
              title: 'Masonary Gallery | Cuba - Premium Admin Template',
            }
          },
          {
            path:"gallery-masonary-desc",
            name:"masonary-desc",
            component:masonary_desc,
            meta: {
              title: 'Masonary Gallery Desc | Cuba - Premium Admin Template',
            }
          }
      
        ]
      },
      {
        path: '/auth',
        children: [
        {
          path: 'login',
          name: 'Login 1',
          component: login,
          meta: {
            title: ' login | Web Admin - BIS',
          }
        },
        {
          path: 'register',
          name: 'register 1',
          component: Register,
          meta: {
            title: ' Register | Cuba - Premium Admin Template',
          }
        }
        ]
      },
      {
        path:"/table",
        component:Body,
        children:[
          {
            path:"basic",
            name:"basic1",
            component:BootstrapBasic,
            meta: {
              title: ' Basic Tables | Cuba - Premium Admin Template',
            }
          },
          {
            path:"tableComponent",
            name:"tableComponent",
            component:tableComponent,
            meta: {
              title: ' Table Components | Cuba - Premium Admin Template',
            }
          },
          
          {
            path:"/datatable-basic",
            name:"datatable",
            component:DatatableBasic,
            meta: {
              title: ' Basic Init | Cuba - Premium Admin Template',
            }
          },
     
        ]
      },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
  })

  // console.log('createRouter')

  var LoginAuthStore = null;

  router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }

    // 오류 방지용?
    if (LoginAuthStore === null) {
      LoginAuthStore = useLoginAuth(router)
    }

    const noSessionPages = ['/authentication/forgetpassword']; //'/auth/register',

    if (to.path === '/login' || to.path === '') {
      // console.log('createRouter - login or empty')

      // 이미 로그인 했는데, 로그인으로 이동 요청시
      // default 페이지로 이동
      if (LoginAuthStore.userLoggedIn) {
        // console.log('userLoggedIn true')
        return next({name: 'orderList'})
      }
    } else {
      // 로그인 페이지 외 특정 페이지 이동 요청시
      // console.log('createRouter - login or empty else')

      if (!noSessionPages.includes(to.path) && !LoginAuthStore.userLoggedIn) {
        // console.log('not a noSessionPages')

        // console.log(to.path)
        // console.log(LoginAuthStore.getAccessToken)
        // console.log(LoginAuthStore.userLoggedIn)

        return next({name: 'LoginView'})
      }
    }

    // console.log('passed. if, else')
    return next()
  });
  export default router